export default __webpack_public_path__ + "static/media/Create_Link_Icon.1cb91547.svg";